module.exports = __webpack_public_path__ + "static/media/curico.fb7233bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/andimar/destinations/curico.png
// module id = 1171
// module chunks = 0